import { useTranslation } from 'react-i18next';
import type { IconName } from '../../icons/types';
import type { ToastAppearance } from './types';

/** `appearance` → icon. Every appearance has its own dedicated icon. */
const APPEARANCE_TO_ICON: Record<ToastAppearance, IconName> = {
  success: 'status_success_fill',
  error: 'status_error_fill',
  info: 'status_info_fill',
  warning: 'status_warning_fill',
};

type UseToastParams = {
  appearance?: ToastAppearance;
};

type UseToastResult = {
  dismissAriaLabel: string;
  iconName?: IconName;
};

export default function useToast({ appearance }: UseToastParams): UseToastResult {
  const { t } = useTranslation();

  const iconName = appearance ? APPEARANCE_TO_ICON[appearance] : undefined;

  return {
    dismissAriaLabel: t('actions:Close'),
    iconName,
  };
}
